<template>
  <v-container fluid grid-list-md pa-0 ma-0>
    <v-card elevation="0" pa-0 ma-0>
      <v-card-title v-if="show">
        <v-icon>mdi-apps</v-icon>&nbsp;
        {{ $t('queues.dashboard') }}
      </v-card-title>
      <Stats v-if="show" />
      <JumboTron v-if="!show" />
      <v-container>
        <v-flex xs12 class='layout row wrap'>
            <v-flex xl4 lg6 md12 xs12 v-for="(queue, key) in queues" :key="key">
              <QueueCard :queue="queue"/>
            </v-flex>
        </v-flex>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Stats from './stats'
import JumboTron from './jumbotron'
import QueueCard from './card'

export default {
  name: 'queues-panel',
  computed: {
    ...mapGetters({
      queues: 'queues/watchedQueues',
      navMini: 'queues/getNavMini',
      showAgents: 'queues/agentsPaneShow'
    }),
    show: function () {
      return this.queues?.length > 0
    },
    mini: function () {
      return (this.navMini && !this.showAgents)
    }
  },
  components: { Stats, JumboTron, QueueCard }
}
</script>

<style scoped>
</style>
